__webpack_require__.p = "https://ayayem.github.io/new-world-skill-xp/";